// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-m_fB","advertDetailContactGroup__header":"c-m_fC","advertDetailContactGroup__value":"c-m_fE"};